var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"自己紹介情報","bread-crumbs":_vm.breadCrumbs}},[_c('div',[_c('base-error-guard',[_c('introduction-list-table')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }